<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="$refs.myTable.search()"
      >
        <a-form-model-item label="员工名称">
          <a-input
            placeholder="请输入员工名称"
            v-model="ajaxparams.employee_name_like"
          />
        </a-form-model-item>
        <a-form-model-item label="检测时间">
          <a-range-picker
            v-model="dateRange"
            @change="onDateChange"
            :placeholder="['开始日期', '结束日期']"
            format="YYYY-MM-DD"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button icon="search" @click="$refs.myTable.search()" type="primary"
            >搜索</a-button
          >
          <a-button @click="reset()" style="margin-left: 8px">重置</a-button>
        </a-form-model-item>
      </a-form-model>

      <MyTable
        class="mt10"
        :apiUrl="packingGoods_efficiency"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
        :isSelection="false"
      >
        <template slot="type" slot-scope="text">
          <a-tag :color="getTypeColor(text)">{{ getTypeText(text) }}</a-tag>
        </template>
        <template slot="total_time" slot-scope="text">
          <span>{{ text }} 秒</span>
        </template>
        <template slot="avg_time" slot-scope="text">
          <span>{{ text }} 秒</span>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import { packingGoods_efficiency } from "@/api/quality";

export default {
  name: "QualityEfficiency",
  components: { MyTable },
  data() {
    return {
      packingGoods_efficiency: packingGoods_efficiency,
      ajaxparams: {},
      dateRange: [],
      columns: [
        {
          title: "员工名称",
          dataIndex: "employee_name",
          key: "employee_name",
          width: 160,
        },
        {
          title: "日期",
          dataIndex: "create_date",
          key: "create_date",
          width: 140,
        },
        {
          title: "类型",
          dataIndex: "type",
          key: "type",
          width: 120,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "总次数",
          dataIndex: "total_times",
          key: "total_times",
          width: 100,
        },
        {
          title: "异常次数",
          dataIndex: "fail_times",
          key: "fail_times",
          width: 100,
        },
        {
          title: "总时长(秒)",
          dataIndex: "total_time",
          key: "total_time",
          width: 120,
          scopedSlots: { customRender: "total_time" },
        },
        {
          title: "平均时长(秒)",
          dataIndex: "avg_time",
          key: "avg_time",
          width: 140,
          scopedSlots: { customRender: "avg_time" },
        },
      ],
    };
  },
  methods: {
    reset() {
      this.ajaxparams = {};
      this.dateRange = [];
      this.$refs.myTable.search();
    },
    onDateChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.ajaxparams.create_date_between = `${dateStrings[0]} - ${dateStrings[1]}`;
      } else {
        delete this.ajaxparams.create_date_between;
      }
    },
    getTypeText(type) {
      const map = { 1: "女工计件", 2: "全自动线", 3: "内袋线" };
      return map[type] || "-";
    },
    getTypeColor(type) {
      const map = { 1: "blue", 2: "green", 3: "orange" };
      return map[type] || "default";
    },
  },
};
</script>

<style scoped></style>
